import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"

function ProtectedOwnerRoute({ children }) {
  const { user, isAdmin, isOwner, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user || (!isAdmin && !isOwner)) {
    return <Navigate to="/" />
  }

  return children
}

export default ProtectedOwnerRoute

